<template>
  <div class="modal-body d-flex justify-content-center align-items-center min-vh-25">
    <div
      class="d-flex flex-column align-items-center text-center p-4 bg-white rounded"
      style="min-width: 280px; width: 100%; max-width: 400px;"
    >
      <i class="fas fa-spinner fa-spin fa-3x text-primary mb-4" />
      <ParseProgress />
    </div>
  </div>
</template>

<script>

import ParseProgress from './ParseProgress.vue';

export default {
  name: 'SpinnerLoader',
  components: {
    ParseProgress
  }
}

</script>
